import styled from 'styled-components/macro';

export const StyledAnchor = styled.a`
  background-color: inherit;
  border-radius: 4px;
  padding: 3px;
  border: 1px solid transparent;
  cursor: pointer;

  :hover {
    border: 1px solid #2d67d8;
  }
`;
